(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      content: '[data-content]',
      input: '[data-variant-id-input]',
      sellingPlanInput: 'input[name="selling_plan"]',
      addOnBtns: '.btn-add-addon',
      stickyIndicator: '.sticky-indicator',
      stickyImage: '.sticky-variant-image'
    };
    async render() {
      this._enableInput();
      this.cartSection = document.querySelector('main-cart');
      this.isProductPage = this.getAttribute('page-type') === 'product';
      this.listenTo('variantChange', (e, data) => {
        this._rerender(data);
        if (data.variant) {
          this._rerenderVariantInput(data);
          
          if (data.variant.featured_image && (this.$stickyImage !== null)) {
            this.$stickyImage.src = data.variant.featured_image.src + '&crop=center&width=65&height=65'
          }
        }
      });
      this.on('cartChange', (e, data) => {
        this._updateQtyStatus(data.variantId)
      }, false)
      if (this.hasAttribute('cart-popup'))
        this.$form.addEventListener('submit', this._handleSubmit.bind(this));
        
      let stickyIndicator = this.$stickyIndicator;
      document.addEventListener('scroll', function() {
        var body = document.querySelector('body');
        var bounding = stickyIndicator.getBoundingClientRect();
        var myElementHeight = stickyIndicator.offsetHeight;
        var myElementWidth = stickyIndicator.offsetWidth;

        var bounding = stickyIndicator.getBoundingClientRect();

        if (bounding.top >= -myElementHeight 
            && bounding.left >= -myElementWidth
            && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
            ) {

            body.classList.remove('form-sticky');
        } else {
          body.classList.add('form-sticky');
        }
      });
        
      document.querySelectorAll(this.elements.addOnBtns).forEach((addOn) => {
        addOn.addEventListener('click', this._handleAddOnClk.bind(this, addOn));
      });
      
      if (this.$sellingPlanInput && this.hasAttribute('selling-plan-enable')) {
        this.currentSellingPlanId = this.querySelector('input[name="selling_plan"]').value;
        const {observeInputValueChange} = await import(window.theme.modules.sellingPlanUtil);
        observeInputValueChange(this.$sellingPlanInput, this._handleSellingPlanChange.bind(this));
      }
    };
    
    _handleSellingPlanChange(newSellingPlanId) {
      if (newSellingPlanId === this.currentSellingPlanId) 
        return;      
      this.currentSellingPlanId = newSellingPlanId;
      const { queryURL, currentURL } = updateURLParams({ 'selling_plan': this.currentSellingPlanId, 'variant': this.getAttribute('current-variant') }, this.sectionId);
      if (this.isProductPage)
        historyPush(currentURL);
      this._fetchPageWithVariant(queryURL, html => {
        this.forwardEvent('sellingPlanChange', {
          html: html
        })
      }); 
    };

    _enableInput() {
      this.$input.disabled = false;
    }
    
    _fetchPageWithVariant(url, onResponse) {
      return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = parseHTML(responseText)
        onResponse(html);
      });
    };

    _rerender(data) {
      console.log(data);
      
      const source = data.html.querySelector(`#${this.getAttribute('form-id')} [data-content]`);
      this.$content.replaceChildren(...source.cloneNode(true).childNodes);
      this._rerenderPaymentButton();
      
      
    };
    _rerenderVariantInput(data) {
      this.setAttribute('current-variant', `${data.variant.id}`);
      const value = data.html.querySelector(this.elements.input).value;
      this.$input.value = value;
    };
    _rerenderPaymentButton() {
      if (window.Shopify?.PaymentButton?.init) {
        window.Shopify.PaymentButton.init();
      }
    };
    
    _handleAddOnClk(addOn) {
      const _this = this;
      console.log(this);
      const variantId = addOn.dataset.variantId;
      console.log(variantId);
      let items = [];
      
      items.push({
        quantity: 1,
        id: variantId * 1
      });
      
      let data_arr = {
        items: items
      };
      
      this.formData = JSON.stringify(data_arr);

      let headerConfig = {
          "Accept": "application/javascript"
      }
      if(typeof(this.formData) == 'string' ) {
        headerConfig = {
                 'Content-Type': 'application/json'
              }
      }
        
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: headerConfig,
        body: this.formData
      })
      .then(res => {
        return res.json();
      })
      .then((data) => {
        if (data.status === 422) {
          console.warn(data);
        } else {
          this.trigger('updateCart', {
            callback: () => {
  
              if(typeof(this.formData) != 'string' ) {
                // this._updateQtyStatus(this.formData.get('id'));
              } else {
                let formDataJson = JSON.parse(this.formData);
                // this._updateQtyStatus(formDataJson.items[0].id);
              }
              
              if(this.cartSection) {
                this.cartSection.update();
              } else {
                this.trigger('openPopup', { target: 'CART' });
              }
            }
          }) 
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
    
    _handleSubmit(e) {
      e.preventDefault();
      this.formData = new FormData(e.target);
       
      const _this = this;
      const ParentEl_Id = this.getAttribute('section-id');
      const ParentEl =   document.querySelector('#shopify-section-' + ParentEl_Id);
      if(ParentEl) {
        let isCheckedUpsellProducts = ParentEl.querySelector('.shop-upsells input:checked');
        if(isCheckedUpsellProducts) {
        let items = [];

          let qtyData = 1;
          if(ParentEl.querySelector('[name="quantity"]')) {
            qtyData = ParentEl.querySelector('[name="quantity"]').value;
          }
          
          let mainData = {
              quantity:qtyData,
                id:_this.getAttribute('current-variant') * 1
          }
          items.push(mainData);
          
        const upsellsArr = ParentEl.querySelectorAll('.shop-upsells input:checked');
          if(upsellsArr.length) {
            upsellsArr.forEach(function(input,index) {

              let upsellId = input.closest('label').getAttribute('data-pid') * 1;
          
               items.push({
                  quantity:1,
                  id:upsellId
               });
              
            });
          }

           let data_arr = {
              items: items
            };
          this.formData = JSON.stringify(data_arr) ;
     
          
        }
      }
       this._addToCartRequest();


    };

    _addToCartRequest() {
      this._setLoading(true);

      let headerConfig = {
          "Accept": "application/javascript"
      }
      if(typeof(this.formData) == 'string' ) {
        headerConfig = {
                 'Content-Type': 'application/json'
              }
      }
        
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: headerConfig,
        body: this.formData
      })
      .then(res => {
        return res.json();
      })
      .then((data) => {
        if (data.status === 422) {
          if (!data.description) {
            console.warn(data);
            return;
          }
          if (data.description.email != null) {
            var giftError = this.querySelector('.errors-gift');
            giftError.innerHTML = 'Email ' + data.description.email;
          } else {
            this.append(error); 
          }
          this._setLoading(false);
        } else {
          this.trigger('updateCart', {
            callback: () => {
              this._setLoading(false);
  
              if(typeof(this.formData) != 'string' ) {
              this._updateQtyStatus(this.formData.get('id'));
              } else {
                let formDataJson = JSON.parse(this.formData);
                this._updateQtyStatus(formDataJson.items[0].id);
              }
              if(this.cartSection) {
                this.cartSection.update();
              } else {
                this.trigger('openPopup', { target: 'CART' });
              }
            }
          }) 
        }
      })
      .catch(error => {
        this._setLoading(false);
        console.log(error);
      });
    };

    _updateQtyStatus(variantId) {
      const url = `${this.getAttribute('product-url')}?variant=${variantId}&section_id=${this.getAttribute('section-id')}`;
      this._fetchPageWithVariant(url, html => {
        this.trigger('qtyStatusUpdate', {html: html, variantId: variantId})
        this._rerender({html: html})
      })
    };
    
    _setLoading(status) {
      status 
        ? this.$addButton.setAttribute('loading', '')
        : this.$addButton.removeAttribute('loading');
      // status ? this.$addButton.setAttribute('disabled', true) :
      //   this.$addButton.removeAttribute('disabled');
      // this.$addButton.textContent = status ? window.theme.i18n.loading : window.theme.i18n.addToCart;
    };
  });
})();